// @flow
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button, ButtonProps } from '@mui/material';
import { lightenHexColor } from '../../../../../shared';

export const NavButton = ({
  to,
  sx = {},
  color,
  ...props
}: Omit<ButtonProps, 'color'> & { color?: string; to: string }) => (
  <Button
    variant={'outlined'}
    component={Link}
    to={to}
    {...props}
    sx={{
      flexDirection: 'column',
      alignItems: 'center',
      p: 1,
      borderColor: color,
      '&:hover': { borderColor: color, backgroundColor: color ? lightenHexColor(color, 90) : color },
      ...sx,
    }}
  >
    {props.children}
  </Button>
);
